var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 50,
    viewBox: "0 0 60 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.798832 44.4349C-0.266277 45.5002 -0.266277 47.2271 0.798832 48.2924C1.86389 49.3571 3.59069 49.3571 4.65574 48.2924L26.4739 26.4739C27.539 25.4089 27.539 23.6821 26.4739 22.617L4.65574 0.798832C3.59069 -0.266277 1.86389 -0.266277 0.798832 0.798832C-0.266277 1.86389 -0.266277 3.59069 0.798832 4.65574L20.6885 24.5455L0.798832 44.4349ZM33.5261 44.4349C32.461 45.5002 32.461 47.2271 33.5261 48.2924C34.5912 49.3571 36.318 49.3571 37.383 48.2924L59.2015 26.4739C60.2662 25.4089 60.2662 23.6821 59.2015 22.617L37.383 0.798832C36.318 -0.266277 34.5912 -0.266277 33.5261 0.798832C32.461 1.86389 32.461 3.59069 33.5261 4.65574L53.4158 24.5455L33.5261 44.4349Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadRight);
export default __webpack_public_path__ + "static/media/load-right.02ce0f06843449d1c253321c53401db4.svg";
export { ForwardRef as ReactComponent };